<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else class="row justify-content-center">
            <div v-if="profile" class="col-md-6 mb-5">
                <alert-success :form="form" :class="'shadow-sm'" message="Your changes have been saved!"></alert-success>

                <h3 class="tx-color-01 mg-b-30">Your risk profile: {{ profile.name }}</h3>
                <p class="mg-b-10">(As of: {{ profile.updated_at|toDate('DD/MM/YYYY') }})</p>
                <p class="tx-color-03 mg-b-30">
                    The goal of your investment strategy is to keep you able to meet any of life's needs
                    as and when they arise, with minimum fuss.
                </p>
                <!-- <div class="col-12 border-top mt-3">
                    <button type="button" class="btn btn-default float-right mt-3 shadow-sm" disabled>Change Risk Profile</button>
                </div> -->
            </div>
        </div>
	</div>
</template>

<style scoped>
</style>

<script>
	import store from "../../../../store";

	export default {
		data() {
			return {
				error: null,
				profile: null,
				form: new Form({})
			};
		},
		beforeRouteEnter(to, from, next) {
			axios
				.get(
					`/api/customers/${store.getters.user.customer.external_client_id}`,
					{
						params: {
							type: "risk_profile"
						}
					}
				)
				.then(response => {
					const profile = response.data.data.risk_profile;

					if (!_.isEmpty(profile)) {
						next(vm => vm.setData(null, profile));
					}
				})
				.catch(error => {
					next(vm => vm.setData(error, null));
				});
		},
		watch: {},
		methods: {
			setData(err, profile) {
				if (err) {
					this.error = err.toString();
				} else {
					this.profile = profile;
				}
			}
		}
	};
</script>
